import { DateTime } from 'luxon';
import React, { useState } from 'react';
import { BrowserView } from 'react-device-detect';
import { Link } from 'react-router-dom';

import { useToast } from 'Component/Alerta';
import Botao from 'Component/Botao';
import Form, { CaixaDeTexto } from 'Component/Form';
import Imagem from 'Component/Imagem';
import Modal from 'Component/Modal';
import AprovarIndisponibilidade from 'Interface/AprovarIndisponibilidades';
import { useAppSelector } from 'Store';
import { useEditarAprovarIndisponibilidadeMutation } from 'View/Service/Default/AprovarIndisponibilidades';

interface Props {
  dados: AprovarIndisponibilidade;
}

const Lista = ({ dados }: Props): React.ReactElement => {
  const usuario = useAppSelector((estado) => estado.autenticacao.usuario);
  const toast = useToast();
  const [modal, setModal] = useState<boolean>(false);
  const [editarAprovacao] = useEditarAprovarIndisponibilidadeMutation();

  const aprovar = async (): Promise<void> => {
    try {
      await editarAprovacao({
        id: dados.id,
        aprovou_id: usuario?.id,
        aprovado: 1,
      }).unwrap();

      toast({
        conteudo: 'Aprovado com sucesso!',
        tema: 'success',
      });
    } catch (erro) {
      toast({
        titulo: 'Erro ao aprovar',
        conteudo: 'Verifique o registro de log para mais detalhes!',
        tema: 'danger',
      });
    }
  };

  const reprovar = async (
    aprovacao: AprovarIndisponibilidade
  ): Promise<void> => {
    try {
      await editarAprovacao({
        id: dados.id,
        aprovou_id: usuario?.id,
        aprovado: 0,
        motivo: aprovacao.motivo,
      }).unwrap();

      toast({
        conteudo: 'Reprovar com sucesso!',
        tema: 'success',
      });
    } catch (erro) {
      toast({
        titulo: 'Erro ao reprovar',
        conteudo: 'Verifique o registro de log para mais detalhes!',
        tema: 'danger',
      });
    }
  };

  return (
    <div className="d-flex border-bottom align-items-center py-2 px-3">
      <Link to={`/usuarios/editar/${dados.id}`}>
        <Imagem
          src={dados.indisponibilidade?.usuario?.imagem}
          alt={dados.indisponibilidade?.usuario?.nome}
          className="rounded-circle object-fit-cover"
          width="80"
          height="80"
        />
      </Link>
      <div className="ms-4 fs-5">
        <Link
          to={`/usuarios/editar/${dados.id}`}
          className="text-decoration-none"
        >
          {dados.indisponibilidade?.usuario?.nome}
        </Link>
        <small className="d-block fs-6 text-muted">
          {dados.indisponibilidade?.motivo}<br />
          {dados.aprovou && (
            <small>
              {dados.aprovado == 1 ? 'Aprovado' : 'Reprovado'} por {dados.aprovou?.nome}
            </small>
          )}
        </small>
      </div>
      <BrowserView className="d-flex flex-grow-1 align-items-center justify-content-end">
        <div className="ms-5 fs-6 text-end text-nowrap">
          {dados.indisponibilidade?.inicio
            .data()
            .toLocaleString(
              dados.indisponibilidade?.inicio !=
                dados.indisponibilidade?.termino
                ? DateTime.DATETIME_SHORT
                : DateTime.DATE_SHORT
            )}
          {dados.indisponibilidade?.inicio !=
            dados.indisponibilidade?.termino &&
            ` até ${dados.indisponibilidade?.termino
              .data()
              .toLocaleString(DateTime.DATETIME_SHORT)}`}
          <small className="d-block fs-6 text-muted">
            Folga solicitada para
          </small>
        </div>
        <div className="ms-5 fs-6 text-end text-nowrap">
          {dados.criado.data().toLocaleString(DateTime.DATETIME_SHORT)}
          <small className="d-block fs-6 text-muted">Solicitado em</small>
        </div>
        {![0, 1].includes(dados.aprovado) &&
          (dados.usuario_id == usuario?.id ||
            usuario?.permissao == 'super') && (
            <div className="ms-5 fs-6 text-end text-nowrap">
              <Botao
                icone="check-lg"
                tema="success"
                confirmacao="Você tem certeza que deseja aprovar essa solicitação?"
                onClick={aprovar}
              />
              <Botao
                ms
                icone="hand-thumbs-down-fill"
                tema="danger"
                onClick={() => setModal(true)}
              />
            </div>
          )}
      </BrowserView>
      <Modal exibir={modal} titulo="Reprovar solicitação" aoFechar={setModal}>
        <Form onSubmit={reprovar}>
          <CaixaDeTexto
            name="motivo"
            rotulo="Motivo por estar reprovando (opcional)"
          />
          <div className="mt-5">
            <Botao type="submit">Reprovar</Botao>
            <Botao ms tema="light" onClick={() => setModal(false)}>
              Cancelar
            </Botao>
          </div>
        </Form>
      </Modal>
    </div>
  );
};

export default Lista;
